module.exports = __webpack_public_path__ + "img/supported_db.5017c639.svg";